import { useEffect, useState } from "react";
import {
  StepContainer,
  StepSeparator,
  StepSymbol,
  StepText,
  StepsWrapper,
} from "./atoms";

type StepsProps = {
  items: {
    title: string;
    key?: string;
  }[];
  current?: number;
  // onChange?: (current: number) => void;
};

export const Steps = ({ items, current }: StepsProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    if (current !== undefined) {
      setActiveIndex(current);
    }
  }, [current]);
  return (
    <StepsWrapper>
      {items.map((item, index) => {
        return (
          <StepContainer className="step-container" key={item?.key || index}>
            <StepSymbol active={activeIndex >= index}>{index + 1}</StepSymbol>
            <StepText
              active={activeIndex >= index}
              className={item.title.length < 5 ? "" : "abroad-style"}
            >
              {item.title}
            </StepText>
            <StepSeparator active={activeIndex > index} className="separator" />
          </StepContainer>
        );
      })}
    </StepsWrapper>
  );
};
